module.exports = __webpack_public_path__ + "media/images/911-icon-b756cb45c5c51ec9f13a91b4d02f1cad.svg";